import React, { useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "../App.css";
import { baseurlvmkp } from "../Files/Subjects/Baseurl";

const BASE_URL = "/vmkp";
const API_URL = "/vmkp/api";

const api = axios.create({
  headers: {
    Authorization: "Bearer " + localStorage.getItem("staffToken"),
  },
});

function ExamScoreByDate() {
  const [fromDate, setFromDate] = useState("");
  const [loading, setLoading] = useState(false);

  // 🔢 Progress states
  const [totalExams, setTotalExams] = useState(0);
  const [processedExams, setProcessedExams] = useState(0);

  const exportExcel = async () => {
    if (!fromDate) {
      alert("Select Date");
      return;
    }

    try {
      setLoading(true);
      setTotalExams(0);
      setProcessedExams(0);

      // 1️⃣ FETCH EXAMS BY DATE
      const examRes = await api.get(
        `${BASE_URL}/excel/getcu/${fromDate}/${fromDate}`
      );

      const exams = examRes.data || [];
      const examIds = exams.map((x) => x.examid).filter(Boolean);

      if (!examIds.length) {
        alert("No exams found for selected date");
        return;
      }

      setTotalExams(examIds.length);

      const rows = [];

      // 2️⃣ PROCESS EACH EXAM
      for (const examId of examIds) {
        // EXAM
        const exam = (
          await api.get(`${baseurlvmkp}/exam/getexam/${examId}`)
        ).data;

        const userId = exam.userId;

        // USER
        const user = (
          await api.get(`${baseurlvmkp}/vmkp/get/${userId}`)
        ).data;

        // SCORE
        const indexRes = await api.get(
          `${baseurlvmkp}/index/get/${userId}/${examId}`
        );

        let score = {};
        if (Array.isArray(indexRes.data)) {
          score = indexRes.data[0] || {};
        } else {
          score = indexRes.data?.data || indexRes.data || {};
        }

        rows.push({
          EXAM_ID: examId,
          USER_ID: user.id,
          FULL_NAME: `${user.first_name} ${user.last_name}`,
          EMAIL: user.email,
          PHONE: user.phone_no,
          AGE: user.age,
          GENDER: user.gender,
          CITY: user.city?.name,
          STATE: user.states?.name,

          STATUS: exam.status,
          START_DATE: exam.start_date,
          END_DATE: exam.end_date,

          APPLICABILITY: score.applicability ?? 0,
          AVERAGE: score.average ?? 0,
          CRITICALITY: score.criticality ?? 0,
          FUTURALITY: score.futurality ?? 0,
          HEALTH: score.health ?? 0,
          RELATIONSHIPS: score.relationships ?? 0,
          SELF_AWARENESS: score.selfAwareness ?? 0,
          WEALTH: score.wealth ?? 0,
          WORK_EDUCATION: score.workEducation ?? 0,
          WORKABILITY: score.workability ?? 0,
          X_AXIS: score.x_AXIS ?? 0,
          Y_AXIS: score.y_AXIS ?? 0,
        });

        // ✅ update progress
        setProcessedExams((prev) => prev + 1);
      }

      // 3️⃣ EXPORT EXCEL
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "UserScores");

      const buffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        `user_scores_${fromDate}.xlsx`
      );
    } catch (err) {
      console.error("EXPORT ERROR ❌", err);
      alert("Export failed, check console");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="card-body">
        <h2 style={styles.title}>Export User Scores</h2>
        <p style={styles.subtitle}>
          Select a date to fetch exams and export user scores
        </p>

        <div style={styles.field}>
          <label style={styles.label}>Date</label>
          <input
            type="date"
              className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            style={styles.input}
          />
        </div>

        <button
          onClick={exportExcel}
          disabled={loading}
          style={{
            ...styles.button,
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? "Processing exams..." : "Export Excel"}
        </button>

        {/* 📊 Progress Info */}
        {loading && (
          <div style={styles.progress}>
            <p>Total exams found: <b>{totalExams}</b></p>
            <p>Fetched: <b>{processedExams}</b></p>
            <p>Remaining: <b>{totalExams - processedExams}</b></p>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  title: {
    margin: 0,
    fontSize: 22,
    fontWeight: 600,
  },
  subtitle: {
    marginTop: 6,
    marginBottom: 24,
    fontSize: 14,
    color: "#666",
  },
  field: {
    marginBottom: 20,
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: 13,
    marginBottom: 6,
    color: "#444",
  },
  input: {
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #d0d5dd",
    fontSize: 14,
  },
  button: {
       width: "20%",

    padding: "12px 16px",
    borderRadius: 10,
    border: "none",
    background: "#4f6ef7",
    color: "#fff",
    fontSize: 15,
    fontWeight: 600,
    cursor: "pointer",
  },
  progress: {
    marginTop: 16,
    padding: 12,
    background: "#f4f6fb",
    borderRadius: 8,
    fontSize: 14,
  },
};

export default ExamScoreByDate;
